<template>
	<div>
		<div class="bodywrap">
			<!--<div class="head">
				已选择：<em>{{styleName}}</em>
			</div>-->
			<header>
				<a href="javascript:window.history.go(-1);" class="headback"></a>
				<span>已选择：<em>{{styleName}}</em></span>
			</header>
			<div class="formwrap">
				<div class="forminputwrap">
					<em class="signUpfrom-icon signUpfrom-icon01"></em>
					<input type="text" v-model="phone" placeholder="请输入购车人手机号码" name="phone" id="phone" value="" />
				</div>
				<div class="forminputwrap">
					<em class="signUpfrom-icon signUpfrom-icon02"></em>
					<input type="text" v-model="userName" placeholder="请输入购车人姓名 " name="userName" id="userName" value="" />
				</div>
				<div class="forminputwrap">
					<em class="signUpfrom-icon signUpfrom-icon03"></em>
					<select class="form-select" id="buyType" style="background:#FFFFFF;">
						<option value="">请选择购车方式</option>
						<option v-for="(item,index) in relustBuyCars" :value="item.value">{{item.name}}</option>
					</select>
					<em class="arror"></em>
				</div>
				<div class="forminputwrap">
					<em class="signUpfrom-icon signUpfrom-icon03"></em>
					<select class="form-select" id="splitMoney" style="background:#FFFFFF;">>
						<option value="">请选择是否分期</option>
						<option value="0">全款</option>
						<option value="1">分期</option>
					</select>
					<em class="arror"></em>
				</div>
				<button class="applyBtn" :disabled="disabled" @click="appValidate">询底价</button>
				<div class="addxyroom"><em class="addxyIcon"></em>同意
					<a href="javascript:void(0);" class="addxydetail" @click="addxydetail()">《个人信息保护声明》</a>
				</div>
				<agreementComponent></agreementComponent>
			</div>
			<!--新增经销商-->
			<div class="dealerwrap">
				<div class="dealerTit">
					<em>【北京】</em> 已为推荐经销商服务
				</div>
				<ul class="dealerListwrap">
					<li class="clearfix" v-for="(item,index) in curperlist">
					   <em :class="item.show?'redicon':'chekgrayClass'"  @click="isShow(item.id)"></em>
						<div class="delName">
							<em class="redsize">4s店</em>
							<em class="dealcustomer">{{item.nickName}}</em>
						</div>
						<a href="tel:4001-501-501" class="redphone"></a>
					</li>
				</ul>
				<div class="getMore" @click="getMoretext">{{words}}
					<em :class="showAll ?'redicon-t' : 'arrorIcon'"></em>
				</div>
			</div>
		</div>
           	<!-- 底部 -->
			<footerComponent></footerComponent>
	</div>
</template>
<script type="text/javascript">
	import { Toast } from 'mint-ui';
	export default {
		name: 'pricePage',
		data: function() {
			return {
				bodyIsShow: false,
				words: '查看更多经销商',
				showAll: false,
				toLearnList: [],
				curperlist: [],
				phone: "", //手机号,
				userName: "", //姓名,
				relustBuyCars: [], //购车方式
				cityId:"10",
				disabled:false,
			    groupinfo:[],
			    styleName:this.$route.query.styleName
			}
		},
		beforeCreate: function() {
			document.title = "询底价";
			getCommonJsIns.initSingleCSSNEW({
				cssURL: "/css/mapply/signupPhp/pricePage.css"
			});
		},
		mounted: function() {
			var self = this;
			document.title = "询底价";
			//确保重要依赖的js加载完成
			getCommonJsIns.initDefaultJS(self.webReady);
//			self.showList();
            if(self.$route.query.cityId) {//获取ur里面type用于区分跳转
				self.cityId = self.$route.query.cityId
			}
		},
		methods: {
			webReady: function() {
				var self = this;
				self.getbuyWays(); //调用购车方式
				self.initdelDate();
			},
			initdelDate: function(){
				var self = this;
				self.ajaxSubmit.ajax({
					url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.getCustomerList+"?brandId="+self.$route.query.brandId+"&id="+self.cityId,
//url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.getCustomerList+"?brandId="+12+"&id="+10,
					type: "post",
					data: {},
					dataType: 'json',
					async: false,
					success: function(data) {
						console.log(data);
						if(data.responseHeader.status == 200) {
							self.toLearnList = data.response.result;//请求数据赋值
							for(var i = 0; i < self.toLearnList.length; i++) {
//								if(i < 3) {
									self.toLearnList[i].show=true;
//								}
							}
							self.showList();
						} else {
							console.log("请求失败");
						}
					},
					error: function() {
						console.log("error");
					}
				});
			},
			isShow:function(id){
				var self=this;
				var couselist1=[];
				for(var i = 0; i < self.curperlist.length; i++) {
					couselist1.push(self.curperlist[i])
						if(self.curperlist[i].id==id){ 
							couselist1[i].show=!self.curperlist[i].show;
						}
						
					}
				self.curperlist=couselist1;
			},
			getMoretext: function() {
				var self = this;
				if(!self.showAll) { //对文字处理
					self.words = '收起'
				} else {
					self.words = '查看更多经销商';
				}
				self.showAll = !self.showAll;
				self.showList();
			},
			showList: function() {
				var self = this;
				self.curperlist = [];
				if(!self.showAll) {
					for(var i = 0; i < self.toLearnList.length; i++) {
						if(i < 3) {
							self.curperlist.push(self.toLearnList[i]);
						}
					}
				} else {
					self.curperlist = self.toLearnList;
				}
			},
			getbuyWays: function() {
				//购车方式
				var self=this;
				self.ajaxSubmit.ajax({
					url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.buyWays,
					type: "get",
					dataType:'json',
					data: {
						cityId:self.cityId,
					},
					success: function(data) {
						// 判断数据请求状态
						if(data.responseHeader.status == 200) {
							self.relustBuyCars = data.response.result;
						}
					},
					error: function() {
						console.log('error');
					}
				});
			},
			appValidate: function(){
				var self = this;
				if(!self.phone) {
					Toast('请输入手机号');
				} else if(!webCommonUtil.commonFun.isPhone(self.phone)) {
					Toast('请输入正确的手机号');
				} else if(!self.userName) {
					Toast('请输入姓名');
				} else if(!webCommonUtil.commonFun.isName(self.userName)) {
					Toast('请输入正确的姓名');
				} else {
					self.applyBtn();
				}
			},
			applyBtn: function() {
				var self = this;
				self.disabled=true;
				var curWindow = window.location.href;
				var data = {
					"phone": self.phone,
					"name": self.userName,
					"sourceUrl": curWindow,
					"noCheckBrandStyle": 1,
					"cityId":self.cityId,
					'groupbyType': 1,
					"buyType": $("#buyType option:selected").val(),
					"splitMoney": $("#splitMoney option:selected").val(),
					"sourceUrl": curWindow,
					"brandId":self.$route.query.brandId,
					"carStyleId":self.$route.query.id,
					"sourceId":'-1',
					"bmtype":'ask_price'
				}
				self.ajaxSubmit.ajax({
					url: self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.applyForTcjAsyn,
					type: "post",
					data: data,
					dataType: 'json',
					async: false,
					success: function(data) {
						console.log(data);
						if(data.responseHeader.status == 200) {
							   self.disabled=false;
							   Toast('询价成功');       
						} else {
							 self.disabled=false;
							console.log("请求失败");
						}
					},
					error: function() {
						 self.disabled=false;
						console.log("error");
					}
				});
			},
			addxydetail: function() {
				// $(".xymarsk").show();
				// $(".addxypop-mark").show();
				// $('html').css({
				// 	"overflow-y": "hidden"
				// });
				// $('body', 'html').css({
				// 	"position": "fixed",
				// 	"left": "50%",
				// 	"margin-left": "-5rem",
				// 	"top": 0
				// });
				agreementUtil.agreement.init();
			}

		}
	}
</script>


// WEBPACK FOOTER //
// src/views/signupPhp/pricePage.vue